export enum TitleIconKey {
  Documents,
  User,
  Home,
  Contract,
  Handshake,
  Mandate,
  Validation,
}
